// Root export for @symbo.ls/collab-features. Mirrors the shape of
// @symbo.ls/finance-features: one subpath per feature, each bound to
// the governance Supabase project via sdk-bridge.
//
// Current state: the intranet owns the full chat implementation. This
// package exposes a stable surface so future consumers (editor chat
// embed, admin monitoring) can import from here without depending on
// the intranet package directly.

export * as chat from '../chat/src/index.js'
export * as tickets from '../tickets/src/index.js'
export * as docs from '../docs/src/index.js'
export * as meet from '../meet/src/index.js'
export * as notifications from '../notifications/src/index.js'
